<template>
  <div class="business-contact" v-if="content">
    <div data-kbnzone='true' data-id='1' class='kbnzone kbn-zone' id='kbnzone-1'
         data-formcode="[[!FORM;5ebbdad80dc36118f0579757;form-cav-business]]">
      <div class="row">
        <div class="col-md-12" data-elem="form">
          <form id='ncform'>
            <div class='ncFieldct cti5ebbdae20dc36118f0579759 tp'><label>Nom</label>
              <div class='ncField'><input type='text' data-fid='5ebbdae20dc36118f0579759'
                                          name='contact_name'></div>
            </div>
            <div class='ncFieldct cti5ebbdae60dc36118f057975a tp'><label>Prénom</label>
              <div class='ncField'><input type='text' data-fid='5ebbdae60dc36118f057975a'
                                          name='contact_firstname'></div>
            </div>
            <div class='ncFieldct cti5ebbdaeb0dc36118f057975b tp'><label>Téléphone</label>
              <div class='ncField'><input data-fid='5ebbdaeb0dc36118f057975b' type='text'
                                          name='contact_phone'></div>
            </div>
            <div class='ncFieldct cti5ebbdaee0dc36118f057975c tp'><label>Entreprise</label>
              <div class='ncField'><input type='text' data-fid='5ebbdaee0dc36118f057975c'
                                          name='third_label'></div>
            </div>
            <div class='ncFieldct cti5ebbdaf40dc36118f057975e tp'><label>Code postal</label>
              <div class='ncField'><input type='text' data-fid='5ebbdaf40dc36118f057975e'
                                          name='third_adrszipcode'></div>
            </div>
            <div class='ncFieldct cti5ebbdafd0dc36118f0579760 tp'><label>Commentaire</label>
              <div class='ncField'><textarea data-fid='5ebbdafd0dc36118f0579760'
                                             name='contact_comment' rows='5'></textarea></div>
            </div>
            <div class='ncSendZone'><a href='#' class='kbn-form' data-id='5ebbdad80dc36118f0579757'
                                       data-lp='5ebbdb660dc36118f0579762'
                                       data-ct='58aff70f0dc361165cc2c286'
                                      >Envoyer</a>
            </div>
          </form>
          <div class='ncFinality'>Les donn&eacute;es communiqu&eacute;es via le formulaire de
            contact ci-dessus sont collect&eacute;es avec votre consentement et sont destin&eacute;es
            &agrave; City Aventure en sa qualit&eacute; de responsable du traitement. Les donn&eacute;es
            de ce formulaire sont collect&eacute;es &agrave; des fins de gestion de la relation
            client, de sollicitations commerciales et ne sont pas c&eacute;d&eacute;es &agrave; des
            tiers. Les donn&eacute;es de votre compte client sont conserv&eacute;es jusqu&rsquo;&agrave;
            la suppression de votre compte client.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      content: null
    },
    computed: {},
    mounted() {
      let recaptchaScript = document.createElement('script')
      recaptchaScript.setAttribute('src', 'https://addin-koban.com/libapi/kobanform.js')
      document.head.appendChild(recaptchaScript)
      console.log(RegForm)
      if (typeof RegForm == 'function') RegForm('5ebbdad80dc36118f0579757');
      if (typeof RegLP == 'function') RegLP('5ebbdb660dc36118f0579762');
    }
  };
</script>

<style lang="scss">

</style>
